<template>
  <div>
    <RegularRoute :vehicleInfo="vehicleInfo" ref="regularRoute" />
    <MaintenanceRecords :vehicleInfo="vehicleInfo" ref="maintenanceRecords" />
  </div>
</template>

<script>
import RegularRoute from './regularRoute/regularRoute';
import MaintenanceRecords from './maintenanceRecords/maintenanceRecords';
export default {
  components: {
    RegularRoute,
    MaintenanceRecords,
  },
  data () {
    return {
      searchBoxData: {},
      vehicleInfo: null,
    };
  },
  methods: {
    getData () {
      if (this.vehicleInfo) {
        this.$refs.regularRoute.getData();
        this.$refs.maintenanceRecords.getData();
      }
    },
    setVehicleInfo (vehicleInfo) {
      this.vehicleInfo = vehicleInfo;
      this.$refs.regularRoute.setVehicleInfo(vehicleInfo);
      this.$refs.maintenanceRecords.setVehicleInfo(vehicleInfo);
    },
  },
};
</script>

<style>
</style>
